import {
  type TypedUseSelectorHook,
  type UseDispatch,
  useDispatch,
  useSelector,
  type UseStore,
  useStore,
} from 'react-redux';

import type { AppDispatch, AppState, AppStore } from '@/store/store.ts';

export const useAppDispatch: UseDispatch<AppDispatch> = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
export const useAppStore: UseStore<AppStore> = useStore.withTypes<AppStore>();
